var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSizeCon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 11.25H20V18.75H0V1.25H17.5V6.25H18.75V11.25ZM1.25 17.5H6.25V6.25H16.25V2.5H1.25V17.5ZM7.5 17.5H12.5V11.25H17.5V7.5H7.5V17.5ZM18.75 17.5V12.5H13.75V17.5H18.75Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSizeCon);
export default __webpack_public_path__ + "static/media/size_con.831f094ce1439027e3bf0da1b6b2b737.svg";
export { ForwardRef as ReactComponent };